import { render, staticRenderFns } from "./PollHeroBanner.vue?vue&type=template&id=70fdfc83&scoped=true&"
import script from "./PollHeroBanner.vue?vue&type=script&lang=ts&"
export * from "./PollHeroBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PollHeroBanner.vue?vue&type=style&index=0&id=70fdfc83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdfc83",
  null
  
)

export default component.exports